import { HttpResponse } from 'msw';

export const ResponseUtils: { [key: string]: () => Response } = {
  get500: () => new HttpResponse('Internal Server Error', { status: 500 }),
  getSuccess: () =>
    HttpResponse.json({
      status: 'ok',
      message: '処理完了',
    }),
  getSysError: () =>
    HttpResponse.json({
      status: 'error',
      message: 'システムエラーが発生しました。',
    }),
  getE0100: () =>
    HttpResponse.json({
      status: 'plessError',
      message: '該当するデータがありません',
      errorcode: 'E0100',
      strings: [],
    }),
  getE0540: () =>
    HttpResponse.json({
      status: 'plessError',
      message: '設定に失敗しました',
      errorcode: 'E0540',
      strings: [],
    }),
};
